import endpoint from '../secrets-web/src/config/endpoint';
const LOCKER_API_URL = process.env.REACT_APP_LOCKER_API_BASE_URL
const API_URL = process.env.REACT_APP_API_URL

export default {
  ...endpoint,
  USERS_ME: `${LOCKER_API_URL}/v3/sso/me`,
  USERS_ME_FACTOR2: `${LOCKER_API_URL}/v3/sso/me/factor2`,
  ACCESS_TOKEN: `${LOCKER_API_URL}/v3/sso/access_token`,

  LOGOUT: `${LOCKER_API_URL}/v3/users/logout`,
  PM_USERS_ME: `${LOCKER_API_URL}/v3/cystack_platform/pm/users/me`,
  USERS_ME_PRELOGIN: `${LOCKER_API_URL}/v3/cystack_platform/pm/users/me/prelogin`,
  PM_USERS_ME_DELETE: `${LOCKER_API_URL}/v3/cystack_platform/pm/users/me/delete`,
  PM_USERS_ME_PASSWORD: `${LOCKER_API_URL}/v3/cystack_platform/pm/users/me/password`,

  USERS_REGISTER: `${API_URL}/v1/users/me/register`,
  USERS_SESSIONS: `${API_URL}/v1/users/sessions`,
  USERS_ME_ONBOARDING_PROCESS: `${API_URL}/v1/users/me/onboarding_process`,

  WORKSPACE_CREATE_MULTIPLE: `${API_URL}/v1/organizations/:id/members/create_multiple`,
};